import React, { useState } from "react";
import {
  IntroductionIllustration,
  IntroductionIllustrationDetail,
  IntroductionContent,
  IntroductionProfile,
  IntroductionSectionContainer,
  IntroductionSticky,
  CurrentRead,
  CurrentReadAuthor,
  CurrentReadCover,
  CurrentReadLabel,
  CurrentReadLink,
  SocialMediaIcon,
  SocialMediaIconGroup,
  TextUnderline,
} from "./style";

import HomeIllustrationImage from "../../../../assets/images/home-illustration-transparent.png";
import ThinkIllustrationImage from "../../../../assets/images/think-illustration-transparent.png";
import BlibliIllustrationImage from "../../../../assets/images/blibli-illustration-transparent.png";
import TravelokaIllustrationImage from "../../../../assets/images/traveloka-illustration-transparent.png";
import LinkText from "../../../common/link-text";
import BookCall from "../../../common/book-call";
import ExternalArrow from "../../../common/external-arrow";

import LinkedIn from "../../../../assets/images/linkedin.png";
import LinkedInHover from "../../../../assets/images/linkedin-hover.png";
import Medium from "../../../../assets/images/medium.png";
import MediumHover from "../../../../assets/images/medium-hover.png";
import Mail from "../../../../assets/images/mail.png";
import MailHover from "../../../../assets/images/mail-hover.png";

const illustrationMap = new Map([
  ["person", HomeIllustrationImage],
  ["why", ThinkIllustrationImage],
  ["Blibli", BlibliIllustrationImage],
  ["Traveloka", TravelokaIllustrationImage],
]);

const socialMediaList = [
  {
    img: LinkedIn,
    hover: LinkedInHover,
    url: "https://www.linkedin.com/in/freddyas/",
    margin: { left: "0px" },
  },
  {
    img: Medium,
    hover: MediumHover,
    url: "https://fide11s.medium.com",
    margin: {},
  },
  {
    img: Mail,
    hover: MailHover,
    url: "mailto:freddy11sanjaya@gmail.com",
    margin: {},
  },
];

const IntroductionSection: React.FC = ({ children }) => {
  const [illustration, setIllustration] = useState("person");

  const [hoverSocialMedia, setHoverSocialMedia] = useState("");

  const renderHoverText = (value: string) => (
    <TextUnderline
      type="button"
      onMouseEnter={() => setIllustration(value)}
      onFocus={() => setIllustration(value)}
      onClick={() => setIllustration(value)}
    >
      {value}
    </TextUnderline>
  );

  const renderSocialMediaList = () =>
    socialMediaList.map((socialMedia) => (
      <LinkText
        key={socialMedia.url}
        url={socialMedia.url}
        label={
          <SocialMediaIcon
            onMouseEnter={() => setHoverSocialMedia(socialMedia.url)}
            onMouseLeave={() => setHoverSocialMedia("")}
            src={
              hoverSocialMedia === socialMedia.url
                ? socialMedia.hover
                : socialMedia.img
            }
            margin={socialMedia.margin}
          />
        }
      />
    ));

  return (
    <IntroductionSectionContainer>
      <IntroductionSticky>
        <IntroductionIllustration
          src={illustrationMap.get(illustration)}
          alt="Freddy illustration that changes with the highlighted profile words"
        />
        <CurrentRead>
          <CurrentReadCover
            src="https://cdn.penguin.co.uk/dam-assets/books/9780241398302/9780241398302-jacket-large.jpg"
            alt="The Book You Wish Your Parents Had Read by Philippa Perry book cover"
          />
          <div>
            <CurrentReadLabel>Current read</CurrentReadLabel>
            <CurrentReadLink
              href="https://www.goodreads.com/book/show/78298063-the-book-you-wish-your-parents-had-read"
              target="_blank"
              rel="noopener noreferrer"
            >
              The Book You Wish Your Parents Had Read <ExternalArrow />
            </CurrentReadLink>
            <CurrentReadAuthor>Philippa Perry</CurrentReadAuthor>
          </div>
        </CurrentRead>
      </IntroductionSticky>
      <IntroductionContent>
        <IntroductionProfile>
          <IntroductionIllustrationDetail>
            A {renderHoverText("person")} who seeks meaningful work,
            relationships, and ways of doing things. Curious about people’s
            behaviour and the “{renderHoverText("why")}” behind it. I tend to step
            back and see the bigger picture of how things connect. A Visual
            Communication Design graduate, previously at {renderHoverText("Blibli")},
            and {renderHoverText("Traveloka")}, now making room for design,
            writing, and work that feels worth caring about. <BookCall />
          </IntroductionIllustrationDetail>
          <SocialMediaIconGroup>{renderSocialMediaList()}</SocialMediaIconGroup>
        </IntroductionProfile>
        {children}
      </IntroductionContent>
    </IntroductionSectionContainer>
  );
};

export default IntroductionSection;
